module.exports = __webpack_public_path__ + "img/word.584af589.svg";